/* eslint-disable max-len, no-console */

import React, { Component } from 'react';
import MediaQuery from 'react-responsive';
import AdUnit from 'components/AdUnit';
import ShareButtons from '../share-buttons-react';
import NBCTruncate from '../nbc-truncate';
import VideoMeta from '../video-meta';

// Import styles
import './style.scss';

const {
  i18n: {
    __,
  },
} = wp;

/**
 * NBC Live CTA component wrapper.
 */
export default class Nbccta extends Component {
  static propTypes = {
    ctalogo: '',
  };

  static defaultProps = {
    ctalogo: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      activeGracenote: {
        title: '',
        description: '',
      },
    };
  }

  /**
   * Fetch MVPD List
   *
   * TODO: Handle "cached mode"
   */
  componentDidMount() {
    fetch('/wp-json/nbc/v1/gracenote/', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        let datalive = data.live;
        [datalive] = datalive[Object.keys(datalive)[0]];
        if (datalive) {
          this.setState({
            activeGracenote: {
              title: datalive.title,
              description: datalive.description,
            },
          });
        }
      })
      .catch((error) => console.error(error));
  }

  /**
   * Render an ad unit.
   */
  displayAdUnit = () => (
    <div className="video-hero__ad-unit">
      <AdUnit name="topbox" />
      <AdUnit name="mobilemultibox" />
    </div>
  );

  render() {
    const {
      props: {
        ctalogo,
        fromLive,
      },
      state: {
        activeGracenote,
      },
    } = this;
    const { title, description } = activeGracenote;

    const currentTime = new Date();
    const months = [
      __('Jan', 'nbc'),
      __('Feb', 'nbc'),
      __('Mar', 'nbc'),
      __('Apr', 'nbc'),
      __('May', 'nbc'),
      __('Jun', 'nbc'),
      __('Jul', 'nbc'),
      __('Aug', 'nbc'),
      __('Sep', 'nbc'),
      __('Oct', 'nbc'),
      __('Nov', 'nbc'),
      __('Dec', 'nbc'),
    ];
    const currentMonth = currentTime.getMonth();
    const currentTimeFormatted = `${months[currentMonth]} ${currentTime.getDate()}`;

    const appLink = ('telemundo' === nbc.brand) ? `https://telemundo.app.link/VvlIlAeCZcb?utm_medium=affiliate&utm_source=${nbc.market}`
      : `https://nbc.app.link/9pwgGUxqYcb?utm_medium=affiliate&utm_source=${nbc.market}`;

    const liveLogo = ('telemundo' === nbc.brand) ? 'Telemundo' : 'NBC';

    return (
      <div className="video-hero nbc_cta">
        <div className="video-hero__column-wrapper">
          {
            <MediaQuery maxWidth={774}>
              <div className="app_cta">
                <img
                  alt={`${liveLogo} Logo`}
                  src={`${ctalogo}/static/images/${liveLogo}LiveTV-Mobile.png`}
                  srcSet={`${ctalogo}/static/images/${liveLogo}LiveTV-Mobile@3x.png 3x,
                  ${ctalogo}/static/images/${liveLogo}LiveTV-Mobile@2x.png 2x, 
                  ${ctalogo}/static/images/${liveLogo}LiveTV-Mobile.png 1x`}
                />
                <h1>{__('Watch on your phone or tablet through the NBC app.', 'nbc')}</h1>
                <a className="app_cta_button" href={appLink}>
                  {__('Open the NBC App', 'nbc')}
                </a>
              </div>
            </MediaQuery>
          }
          {
            <MediaQuery minWidth={775}>
              <div className="video-hero__column-left">
                <div className="video-hero__video scroll-overflow">
                  <img alt={`${liveLogo} Logo`} src={`${ctalogo}/static/images/${liveLogo}LiveTV-Desktop.png`} />
                  <h1>{__('Login with your TV provider to watch unlimited NBC content on', 'nbc')} <br /><a href={appLink}>www.nbc.com/live</a></h1>
                  <a className="app_cta_button" href={appLink}>
                    {__('Watch Now', 'nbc')}
                  </a>
                </div>
              </div>
              <div className="video-hero__column-right">
                { activeGracenote && (
                  <div className="video-hero__info">
                    { /* TODO: Add link & time */ }
                    <VideoMeta
                      eyebrowLink={__('#', 'nbc')}
                      eyebrowLabel={__('Live TV', 'nbc')}
                      publishedTime={currentTimeFormatted}
                    />
                    { title && (
                      <h2 className="video-hero__title">
                        {title}
                      </h2>
                    )}
                    { description && (
                      <div className="video-hero__text">
                        {
                          <NBCTruncate
                            maxlines="10"
                            maxlinesmobile="3"
                            readmore="Read More"
                            ellipsis="false"
                            text={description}
                          />
                        }
                      </div>
                    )}
                    { /* TODO: Add link */ }
                    {<ShareButtons
                      title={title || ''}
                      href={__('#', 'nbc')}
                      fromLive={fromLive}
                    />}
                  </div>
                )}
                { /* Ad unit goes here */
                  <MediaQuery minWidth={768}>
                    {this.displayAdUnit()}
                  </MediaQuery>
                }
              </div>
            </MediaQuery>
          }
        </div>
        { /* Ad unit goes here */
          <MediaQuery maxWidth={767}>
            <div className="video-hero__row video-hero__row--centered">
              {this.displayAdUnit()}
            </div>
          </MediaQuery>
        }
      </div>
    );
  }
}
